export enum ResultVisualizationType {
    Unknown = 0,
    RadarChart = 1
}